<template>
    <card class="spaced typo">
        
        <h2 class="text-white mb-4">
            {{ $t('auth.change-password') }}
        </h2>

        <form @submit.prevent="submit" @keydown="form.errors.clear($event.target.name)">

            <base-input class="mb-3"
                type="password"
                :label="$t('auth.current-password')"
                :placeholder="$t('auth.current-password')"
                v-model="form.data.current_password"
                name="current_password"
                :error="form.errors.get('current_password')"
            >
            </base-input>

            <base-input class="mb-3"
                type="password"
                :label="$t('auth.new-password')"
                :placeholder="$t('auth.new-password')"
                v-model="form.data.new_password"
                name="new_password"
                :error="form.errors.get('new_password')"
            >
            </base-input>

            <base-input class="mb-3"
                type="password"
                :label="$t('auth.new-password-confirm')"
                :placeholder="$t('auth.new-password-confirm')"
                v-model="form.data.new_password_confirmation"
                name="new_password_confirmation"
                :error="form.errors.get('new_password_confirmation')"
            >
            </base-input>

            <div class="text-center">
                <base-button native-type="submit"
                    type="primary"
                    :disabled="form.errors.any() || invalid"
                    :loading="form.recording"
                >
                    {{ $t('auth.change-password') }}
                </base-button>
            </div>

        </form>
    </card>
</template>

<script>
    import CrudClient from '@trax/classes/CrudClient'
    import CrudForm from '@trax/classes/CrudForm'

    export default {

        data() {
            let client = new CrudClient('/trax/api/front/users/me/password')
            return {
                form: new CrudForm(client, this.mapData),
            }
        },

        created() {
            this.form.create().then(this.succeeded)
        },

        methods: {

            mapData(user) {
                return {
                    current_password: null,
                    new_password: null,
                    new_password_confirmation: null,
                }
            },

            submit() {
                this.form.created()
            },

            succeeded() {
                this.$notify({type: 'success', message: this.$t('auth.password-changed') })
                this.form.create().then(this.succeeded)
            }
        }
    }
</script>
